/* eslint-disable @typescript-eslint/no-unused-vars */

import React from "react";
import styled, { css } from "styled-components";
import * as _ from "lodash";

import InvalidWidgetFilters from "../InvalidWidgetFilters";
import { PendingCustomersWidgetContent } from "./PendingCustomersWidgetContent";
import { WidgetProps } from "../utils";

/**
 * Returns pending customer totals widget content only if no customer or branch filters are applied
 */
export const PendingCustomersWidget: React.FunctionComponent<WidgetProps> = ({ filters, ...rest }) => {
  const wrapperRef = React.createRef<HTMLDivElement>();

  // Exit early if customer or branch filters are applied
  if (filters?.customer || filters?.branch) {
    return <InvalidWidgetFilters mustNotContain={[ "customer", "branch" ]} />;
  }

  return (
    <StyledWrapper ref={wrapperRef}>
      <PendingCustomersWidgetContent
        filters={filters}
        wrapperRef={wrapperRef}
        {...rest}
      />
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  ${({ theme }) => css`
    height: 100%;
    width: 100%;
    padding: ${theme.spacing.padding.sm} 0; 
  `}
`;
